import React, { useEffect, useRef } from 'react'
import { styled, alpha } from '@mui/material/styles'
import InputBase from '@mui/material/InputBase'

import { debounce } from 'lodash'

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  background: 'none',
  marginRight: theme.spacing(2),
  //   marginLeft: 0,
  width: '100%',
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-input': {
    paddingRight: '50px',
    borderRadius: '25px',
  },
}))

type SearchInputProps = {
  onChange: (value: string) => void
  hasDebounce?: boolean
  value?: string
}
const SearchInput = ({ onChange, hasDebounce = false, value = '' }: SearchInputProps) => {
  const searchRef = useRef<HTMLInputElement>(null)

  const handleSearch = hasDebounce
    ? debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
      }, 700)
    : (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
      }

  useEffect(() => {
    if (!value && searchRef.current) {
      searchRef.current.value = ''
    }
  }, [value])

  return (
    <Search>
      <StyledInputBase
        placeholder='Search'
        inputProps={{ 'aria-label': 'search' }}
        onChange={handleSearch}
        inputRef={searchRef}
      />
    </Search>
  )
}

export default SearchInput
